import { Box } from '@mui/material'
import React from 'react'
import DatePickerInput from 'src/Common/ui/DatePickerInput'
import Input from 'src/Common/ui/input'
import { indTimeConvert } from 'src/lib/utils'
import PropTypes from 'prop-types'

function ThresholdDrawer ({ drawType, control, thresholdObject, setThresholdObject }) {
    const handleDateChange = (value, key) => {
        setThresholdObject(prevState => ({
            ...prevState,
            [key]: value
        }))
    }
    const handleInput = (e, key) => {
        setThresholdObject(prevState => ({
            ...prevState,
            [key]: e.target.value
        }))
    }
    const minDate = new Date()
    minDate.setHours(0, 0, 0, 0)
    minDate.setDate(minDate.getDate() - 1)
    return (
        <div className='flex flex-col gap-3 mt-4'>
            <div className='flex flex-col gap-3'>
                <div className='text-primary text-xl font-semibold'>Types</div>
                <div className='text-muted'>{name}</div>
            </div>
            <div className='font-semibold text-primary'>Invested</div>
            <Box display='grid' gridTemplateColumns={'repeat(2, 1fr)'} gap={4}>
                <Box gridColumn='span 1'>
                    <Box gridColumn="span 2">
                        <Input
                            control={control}
                            // required
                            name='investAmount'
                            label={'Amount'}
                            placeholder="Enter Amount"
                            type="number"
                            onValueChange={(e) => { handleInput(e, 'investAmount') }}
                            value={thresholdObject?.investAmount}
                        />
                    </Box>
                </Box>
                <Box gridColumn='span 1'>
                    <DatePickerInput
                        control={control}
                        // required
                        name='investOn'
                        label={'As on'}
                        // register={register}
                        type="text"
                        value={thresholdObject?.investOn }
                        onValueChange={(e) => { handleDateChange(e, 'investOn') }}
                        minDate={indTimeConvert(minDate)}
                    />
                </Box>
            </Box>
            <div className='font-semibold text-primary'>Market Value</div>
            <Box display='grid' gridTemplateColumns={'repeat(2, 1fr)'} gap={4}>
                <Box gridColumn='span 1'>
                    <Box gridColumn="span 2">
                        <Input
                            control={control}
                            // required
                            rules={{
                                // validate: (value) => {
                                //     return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                                // }
                            }}
                            name='marketAmount'
                            label={'Amount'}
                            placeholder="Enter Description"
                            type="number"
                            onValueChange={(e) => { handleInput(e, 'marketAmount') }}
                            value={thresholdObject?.marketAmount}
                            // maxLength={250}
                        />
                    </Box>
                </Box>
                <Box gridColumn='span 1'>
                    <DatePickerInput
                        control={control}
                        // required
                        name='marketOn'
                        label={'As on'}
                        // register={register}
                        type="text"
                        value={thresholdObject?.marketOn }
                        onValueChange={(e) => { handleDateChange(e, 'marketOn') }}
                        minDate={indTimeConvert(minDate)}
                    />
                </Box>
            </Box>
        </div>
    )
}

ThresholdDrawer.propTypes = {
    drawType: PropTypes.any,
    control: PropTypes.any,
    thresholdObject: PropTypes.any,
    setThresholdObject: PropTypes.any
}
export default ThresholdDrawer
